import "./formEmbed.scss";

interface formEmbedProps {
  form: string;
}

const FormEmbed: React.FC<formEmbedProps> = (props) => {
  return (
    <div className="form-embed">
      <iframe src={props.form} width="100%" height="1800" title="form" ></iframe>
    </div>
  );
};

export default FormEmbed;
